import './style.scss';

import { format } from 'date-fns';
import { NumberUtils } from 'modules';
import React from 'react';
import { forwardRef } from 'react';

const PrintThermalInvoice = (
  {
    data,
  }: {
    data?: any;
  },
  ref: any,
) => {
  const period = data?.transaction?.period;
  const month = String(period)?.slice?.(4, 6) || '';
  const year = String(period)?.slice?.(0, 4) || '';

  return (
    <div
      ref={ref}
      className='print-thermal-content page-break line'
      style={{ position: 'relative', margin: 0, fontFamily: 'Roboto' }}
    >
      <div className='wrap-header'>
        <div className='logo'>
          <img
            src='https://ecollect.vitapay.vn/assets/news/images/logo-login.svg'
            width={180}
            style={{ height: 'auto' }}
          />
        </div>
        <div className='wrap-phead'>
          <div className='wrap-time'>
            <div style={{ lineHeight: '17px', marginBottom: '10px' }}>
              <div>Mã giao dịch:</div>
              <div>{data?.transaction?.transactionCode}</div>
            </div>
          </div>
          <div className='wrap-time'>
            <p>
              <span>Thời gian: </span>
              <span>
                {data?.transaction?.payAt
                  ? format(
                      new Date(data?.transaction?.payAt),
                      'HH:mm:ss dd/MM/yyyy',
                    )
                  : ''}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className='title-p'>
        <span>Biên nhận thanh toán</span>
      </div>
      <div className='wrap-pcontent'>
        <table cellPadding={5} cellSpacing='0' width='100%'>
          <tbody>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Mã KH</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>
                  {data?.customer?.customerCode || ''}
                </div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Tên KH</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>{data?.customer?.fullName || ''}</div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Địa chỉ</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>{data?.customer?.address || ''}</div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Dịch vụ</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>
                  {data?.transaction?.transactionType || ''}
                </div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Nhà cung cấp</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>
                  {data?.transaction?.elecProductName || ''}
                </div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Kỳ thanh toán</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>{`${month}/${year}`}</div>
              </td>
            </tr>
            <tr>
              <td className='txt-pleft'>
                <div className='t-left'>Giá trị hóa đơn</div>
              </td>
              <td className='txt-pright'>
                <div className='t-right'>
                  <span className='weight-bold size-13'>
                    {NumberUtils.toCurrency(data?.transaction?.value, 'vnđ')}
                  </span>
                </div>
              </td>
            </tr>
            {/*  Update phí thu hộ */}
          </tbody>
        </table>
        <table
          width='100%'
          className='tbl-footer'
          cellPadding={0}
          cellSpacing={0}
        >
          <tbody>
            <tr>
              <td className='date-pay'>
                Ngày thu:{' '}
                {data?.transaction?.payAt
                  ? format(new Date(data?.transaction?.payAt), 'dd/MM/yyyy')
                  : ''}
              </td>
            </tr>
            <tr>
              <td className='user-pay'>Người thu tiền</td>
            </tr>
            <tr>
              <td className='name-pay'> {data?.execBy?.fullName || ''} </td>
            </tr>
            <tr>
              <td className='phone-support'>
                ĐT hỗ trợ:{' '}
                <b>{data?.execBy?.phoneNumber?.replace(/\+84/, '0')}</b>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default forwardRef(PrintThermalInvoice);
